export default "__VITE_ASSET__LCF7VMgF__"